import './Main.css';
import './CSS/About.css';
import {FooterLinks, HeaderLinks} from "./ToolBox.jsx"
import { Link } from 'react-router-dom';

const Collage = () => {
  return(
    <div class="row">
      <div class="column">
        <img src="/Images/AboutImgs/CChurch.jpeg" alt='sunday school'/>
        <img src="/Images/AboutImgs/Halloween meal.jpg" alt='fall mealtime'/>
        <img src="/Images/AboutImgs/Worship.jpg" alt='worship singing'/>
        <img src="/Images/AboutImgs/Playground.jpeg" alt='New playground'/>
        <p id='bibleVerse'>"Wherefore receive ye one another, as Christ also received us to the glory of God" (Romans 15:7 KJV)</p>
      </div>
      <div class="column">
        <img src="/Images/AboutImgs/Wide View.jpg" alt='Our church'/>
        <img src="/Images/AboutImgs/Builder.jpg" alt='building project'/>
        <img src="/Images/Children's Church.jpg" />
        <img src="/Images/AboutImgs/Singers 2.jpg" alt='second pair of singers'/>
      </div>
      <div class="column">
        <img src="/Images/AboutImgs/Invite.jpeg" alt='Friendly gathering'/>
        <img src="/Images/AboutImgs/Halloween ride.jpeg" alt='Halloween night'/>
        <img src="/Images/AboutImgs/Building.jpeg" alt='Construction project'/>
        <img src="/Images/AboutImgs/Baptism.jpeg" alt='lake baptism'/>
      </div>
      <div class = "column">
        <p id='bibleVerse'>"For where two or three are gathered together in My name, I am there in the midst of them." (Matthew 18:20 NKJV)</p>
        <img src="/Images/AboutImgs/Singers 1.jpg" alt='Pair of singers'/>
        <img src="/Images/AboutImgs/Egg Hunt.jpeg" alt='Easter egg hunt for kids'/>
        <img src="/Images/AboutImgs/Candlelight.jpeg" alt='Christmas candlelights'/>
        <img src="/Images/AboutImgs/Painter.jpg" alt='painting project'/>
      </div>
    </div>
  );
}
const Exposition = () => {
  return(
    <div>
      <div className="dividers">
        <table className="infoTable">
          <tr>
            <td>Our History</td>
            <td>Pennington Chapel (PC) has a rich and enduring history that dates back to its founding in 1840 by Reverend James Pennington. 
              Reverend Pennington, a dedicated servant of God, established the church to serve as a beacon of faith and community. 
              Sadly, he passed away in 1864 while serving in Virginia during the "War Between the States."</td>
          </tr>
        </table>
        <table className="infoTable">
          <tr>
            <td>Progress</td>
            <td>Over the years, the church has seen several transformations, both in its physical structure and its spiritual journey. 
              One notable building was constructed in 1898, with F. R. Seaborn serving as its first pastor. 
              Church members fondly recall the simplicity and challenges of worship in that era (stated down below).</td>
          </tr>
        </table>
      </div>
      <div className="dividers">
        <table className="infoTable">
          <tr>
              <td>Achievements</td>
              <td>A major milestone in PC's history was the groundbreaking for a new building on November 20, 1955. 
                The old structure was dismantled, and a modern church was erected in its place, completed in 1956. 
                This building was dedicated on May 18, 1958, under the leadership of Mr. Bill Martin, the first pastor of the new church. 
                Pennington Chapel has also been part of several charge circuits over the years, including Carnesville, Danielsville, Canon, Sandy Cross, and Vanna.</td>
            </tr>
        </table>
        <table className="infoTable">
          <tr>
            <td>Quote from church members</td>
            <td>"The church was so high off the ground that you could walk underneath it. 
              We nearly froze to death in the winter as there was only a potbelly stove for heat. 
              We sat on slate benches. Service was in the evening and sometimes on Saturday because of circuit preaching."</td>
          </tr>
        </table>
      </div>
      <div className="dividers">
        <table className="infoTable">
          <tr>
            <td>Independence</td>
            <td>As of now, we are proud to stand as an Independent Bible Church (meaning we are not related to any singular denomination), continuing to uphold our commitment to the teaching and preaching of the Bible as well as serving our community with unwavering faith and love. 
              Our journey from 1840 to today is a testament to God's grace and the steadfast devotion of our congregation. 
              As we move forward, we honor our past while embracing the opportunities to grow and serve as an independent body of believers.</td>
          </tr>
        </table>
      </div>
    </div>
  )
}

export default function AboutPage() {
  return(
    <div className="backgroundGradient">
      <Link to="/"><img src="/Images/Chapel Logo.png" alt="Pennington Chapel" /></Link>
      <HeaderLinks />
      <div class="banner">
        <h2 class="bannerText">About Us.</h2>
      </div>
      <Collage />
      <div class="banner">
        <h2 class="bannerText">Our History.</h2>
      </div>
      <Exposition />
      <FooterLinks />
    </div>
  )
}